// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase'

// Initialize Firebase
var config = {
    // apiKey: "YOUR_API_KEY",
    // authDomain: "AUTH_DOMAIN",
    // databaseURL: "DB_URL",
    // projectId: "PROJECT_ID",
    // storageBucket: "STORAGE_BUCKET",
    // messagingSenderId: "SENDER_ID"

    apiKey: "AIzaSyA99L5SItUObZjoMd1dnL-etps0QaWamtA",
    authDomain: "puldaa.firebaseapp.com",
    databaseURL: "https://puldaa-default-rtdb.firebaseio.com/",
    projectId: "puldaa",
    storageBucket: "puldaa.appspot.com",
    messagingSenderId: "596495926807",
    appId: "1:596495926807:web:d666a46c731058d1ed7e52",
    measurementId: "G-QNC424102F"
};

firebase.initializeApp(config);
